import { render, staticRenderFns } from "./PageHeaderNotifications.vue?vue&type=template&id=6d8fca65&scoped=true&"
import script from "./PageHeaderNotifications.vue?vue&type=script&lang=js&"
export * from "./PageHeaderNotifications.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderNotifications.vue?vue&type=style&index=0&id=6d8fca65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8fca65",
  null
  
)

export default component.exports